import React from "react";
import clsx from "clsx";
import styles from "@/styles/Ui.module.scss"
import {invalid_style} from "@/utils/constants.ts";

interface Props {
    className?: string
    name: string
    placeholder?: string
    textarea?:boolean
    type?:string
    value?:string
    onChange?(e:any):void
    maxLength?:number
    id?: string
    onPaste?(e:any):void
    onBlur?(e:any):void
    onFocus?(e:any):void
    defaultValue?:string
    handleKeyDown?(e:any):void
    error?:boolean
    inputMode?:any
}

const TextField:React.FC<Props> = (props) => {
    
    const {
        className,
        name,
        placeholder,
        textarea,
        value,
        onChange,
        maxLength,
        id,
        onPaste,
        onBlur,
        onFocus,
        defaultValue,
        handleKeyDown,
        error,
        inputMode
    } = props
    
    const Element = textarea ? 'textarea' : 'input';
    
    const inputProps = {
        onKeyDown: (e:any) => {
            if (typeof handleKeyDown === "function") {
                handleKeyDown(e);
            }
        },
        
        id: id,
        className: clsx(styles.text_field, className && className),
        placeholder: placeholder,
        name: name,
        onPaste: (e:any) => {
            if (typeof onPaste === "function") {
                onPaste(e);
            }
        },
        maxLength: maxLength && maxLength,
        onFocus: (e:any) => {
            if (typeof onFocus === "function") {
                onFocus(e)
            }
        },
        onBlur: (e:any) => {
            if (typeof onBlur === "function") {
                onBlur(e)
            }
        },
        onChange: (e:any) => {
            if (typeof onChange === "function") {
                onChange(e);
            }
        },

        style: error ? {outline: invalid_style} : {},
        inputMode: inputMode && inputMode
    };
    
    return defaultValue ? (
        <Element
            {...inputProps}
            autoComplete={"off"}
            defaultValue={defaultValue}
            
        />
    ) : (
        <Element
            {...inputProps}
            autoComplete={"off"}
            value={value && value}
        />
    )
}

export default TextField